const isMobile = () => window.innerWidth <= 768;

const initGalleryResponsive = (section) => {
  let swiperInstance = null;
  const sliderWrapper = section.querySelector(".js-product-slider");
  const slides = sliderWrapper.querySelectorAll(".js-product-slide");

  if (!isMobile()) {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
    return;
  }

  if (swiperInstance) return;

  sliderWrapper.classList.add("swiper-wrapper");
  slides.forEach((slide) => slide.classList.add("swiper-slide"));

  const swiperContainer = document.createElement("div");
  swiperContainer.classList.add("swiper", "featured-media-products__swiper");

  sliderWrapper.parentNode.insertBefore(swiperContainer, sliderWrapper);
  swiperContainer.appendChild(sliderWrapper);

  swiperInstance = new Swiper(swiperContainer, {
    slidesPerView: 1.2,
    spaceBetween: 16,
  });
};


const initGalleryPDP = () => {
  const section = document.querySelector(".js-carousel-desktop");

  if (!section || !isMobile()) return;

  new Swiper(section, {
    slidesPerView: 1.2,
    loop: true,
  });
};

const initProductGalleries = () => {
  const productGalleries = document.querySelectorAll(".card-wrapper");
  if (!isMobile()) return;

  // Initialize Swiper for each gallery
  productGalleries.forEach((gallery, index) => {
    const settings = gallery.getAttribute("data-gallery");
    const parsedSettings = JSON.parse(settings);

    console.log("parsedSettings", parsedSettings);

    if (!parsedSettings) return;

    const { id, url, featured_media, media } = parsedSettings;

    if (!media || !media.length) return;

    // Generate a unique ID for the gallery
    const galleryId = `product-gallery-${id}`;

    // Select the container where we'll put our swiper
    const cardInner = gallery.querySelector(".card--product");
    if (!cardInner) return;

    // Create the swiper container structure
    const swiperContainer = document.createElement("div");
    swiperContainer.id = galleryId;
    swiperContainer.className = "swiper-container";

    const swiperWrapper = document.createElement("div");
    swiperWrapper.className = "swiper-wrapper";

    cardInner.innerHTML = `
      <a href="${url}" class="card__media" aria-label="View product">
    
      </a>
    `;

    const cardMedia = cardInner.querySelector(".card__media");

    // Create slides for each media url
    media.forEach((mediaUrl) => {
      const swiperSlide = document.createElement("div");
      swiperSlide.className = "swiper-slide";

      const image = document.createElement("img");
      image.src = mediaUrl.src;
      image.alt = `Product image`;
      image.className = "product-gallery-image";

      swiperSlide.appendChild(image);
      swiperWrapper.appendChild(swiperSlide);
    });

    const scrollbar = document.createElement("div");
    scrollbar.className = "swiper-scrollbar";

    swiperContainer.appendChild(swiperWrapper);
    swiperContainer.appendChild(scrollbar);

    cardMedia.appendChild(swiperContainer);

    new Swiper(`#${galleryId}`, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      loop: true,
      scrollbar: {
        el: `#${galleryId} .swiper-scrollbar`,
        draggable: true,
        hide: false,
      },
    });
  });
};

const initViewMoreButton = () => {
  let currentPage = 1;

  const viewMoreBtn = document.getElementById("view-more-btn");
  const productGrid = document.querySelector("#product-grid");

  if (!viewMoreBtn || !productGrid) return;

  const dataPaginate = viewMoreBtn.getAttribute("data-paginate");
  const paginateData = JSON.parse(dataPaginate);

  const totalPages = paginateData.total_pages;
  const baseUrl = paginateData.next.split("?")[0]; // e.g. "/collections/all"

  // Click event
  viewMoreBtn.addEventListener("click", function (e) {
    e.preventDefault();

    currentPage += 1;

    if (currentPage > totalPages) {
      viewMoreBtn.style.display = "none";
      viewMoreBtn.textContent = "No More Products";
      return;
    }

    viewMoreBtn.classList.add("loading");
    viewMoreBtn.textContent = "Loading...";

    const nextUrl = `${baseUrl}?page=${currentPage}`;

    fetch(nextUrl)
      .then((response) => response.text())
      .then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const newProducts = tempDiv.querySelectorAll(".product-grid__product");

        if (newProducts.length === 0) {
          viewMoreBtn.style.display = "none";
          viewMoreBtn.textContent = "No More Products";
          return;
        }

        newProducts.forEach((product) => {
          productGrid.appendChild(product);
        });

        initProductGalleries();

        if (currentPage >= totalPages) {
          viewMoreBtn.style.display = "none";
          viewMoreBtn.textContent = "No More Products";
        } else {
          viewMoreBtn.classList.remove("loading");
          viewMoreBtn.textContent = "View More";
        }
      })
      .catch((error) => {
        console.error("Error loading more products:", error);
        viewMoreBtn.classList.remove("loading");
        viewMoreBtn.textContent = "Try Again";
      });
  });
};


class GridViewController {
  constructor() {
    this.defaultGridView =  window.defaultGridView || "4";
    this.decreaseViewBtn = document.querySelector(".decrease-view");
    this.increaseViewBtn = document.querySelector(".increase-view");
    this.viewLabel = document.querySelector(".grid-view-control span");
    this.productGrid = document.querySelector("#product-grid");
    this.views = ["2", "4", "8"];

    this.initializeView();
    this.setupEventListeners();
  }

  initializeView() {
    if (this.viewLabel) {
      this.viewLabel.classList.add("view-toggle");
      this.viewLabel.style.cursor = "pointer";
    }

    const urlParams = new URLSearchParams(window.location.search);
    const viewParam = urlParams.get("view");
    const savedView = localStorage.getItem("shopify-grid-view");

    const initialView = viewParam || savedView || this.defaultGridView;
    this.currentViewIndex = this.views.indexOf(initialView.toString());

    if (this.currentViewIndex === -1) {
      this.currentViewIndex = 1;
      console.warn("View not found in views array, defaulting to 4 columns");
    }

    this.applyGridView();
    this.updatePaginationLinks();
  }

  setupEventListeners() {
    if (!this.decreaseViewBtn || !this.increaseViewBtn || !this.productGrid)
      return;

    this.decreaseViewBtn.addEventListener("click", () => {
      if (this.currentViewIndex > 0) {
        this.currentViewIndex--;
        this.applyGridView();
        this.updatePaginationLinks();
      }
    });

    this.increaseViewBtn.addEventListener("click", () => {
      if (this.currentViewIndex < this.views.length - 1) {
        this.currentViewIndex++;
        this.applyGridView();
        this.updatePaginationLinks();
      }
    });

    if (this.viewLabel) {
      this.viewLabel.addEventListener("click", () => {
        this.currentViewIndex = (this.currentViewIndex + 1) % this.views.length;
        this.applyGridView();
        this.updatePaginationLinks();
      });
    }

    this.updateButtonStates();
  }

  applyGridView() {
    if (!this.decreaseViewBtn || !this.increaseViewBtn || !this.productGrid)
      return;

    this.productGrid.classList.remove(
      "grid--2-col-view",
      "grid--4-col-view",
      "grid--8-col-view",
      "grid--2-col-tablet",
      "grid--3-col-tablet",
      "grid--4-col-desktop"
    );

    const currentView = this.views[this.currentViewIndex];
    this.productGrid.classList.add(`grid--${currentView}-col-view`);


    console.log("currentView", this.currentViewIndex, this.productGrid);
    this.productGrid.style.setProperty(
      "--grid-column-count",
      currentView,
      "important"
    );

    this.updateButtonStates();

    if (this.viewLabel) {
      this.viewLabel.textContent = "View";
    }

    localStorage.setItem("shopify-grid-view", currentView);

    console.log(`Grid view set to ${currentView} columns`);
  }

  updateButtonStates() {
    this.decreaseViewBtn.disabled = this.currentViewIndex === 0;
    this.increaseViewBtn.disabled =
      this.currentViewIndex === this.views.length - 1;
  }

  updatePaginationLinks() {
    const currentView = this.views[this.currentViewIndex];
    const paginationLinks = document.querySelectorAll(".pagination a");

    paginationLinks.forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set("view", currentView);
      link.href = url.toString();
    });
  }
}


const assignLinkToHeader = () => {
  const links = document.querySelectorAll("header .summary > a");
  links.forEach((link) => {

    link.addEventListener("click", (e) => {
      e.preventDefault();
      const href = link.getAttribute("href");
      if (!href || href == "#" || isMobile()) return;

      window.location.href = href;
    });

  });
}

class AccordionTabs {
  constructor(selector) {
    this.parent = document.querySelector(selector);
    this.accordions = this.parent?.querySelectorAll('.product__accordion');
    this.container = document.createElement('div');
    this.titlesContainer = document.createElement('div');
    this.wrapper = document.createElement('div');
    this.activeButton = null;
    this.container.classList.add('accordion-content-container');
    this.titlesContainer.classList.add('accordion-titles-container');
    this.wrapper.classList.add('accordion-tabs-wrapper');
    this.build();
  }

  build() {
    this.accordions.forEach((accordion, index) => {
      accordion.classList.add('hidden');
      const title = accordion.querySelector('summary .accordion__title').textContent.trim();
      const content = accordion.querySelector('.accordion__content').innerHTML.trim();
      const button = document.createElement('button');
      button.textContent = title;
      button.classList.add('accordion-title-button');
      button.dataset.index = index;
      this.titlesContainer.appendChild(button);
      accordion.dataset.content = content;
    });

    this.wrapper.appendChild(this.container);
    this.wrapper.appendChild(this.titlesContainer);

    this.parent.querySelector('#accordion-wrapper')?.appendChild(this.wrapper);

    this.titlesContainer.addEventListener('click', e => {
      if (e.target.matches('button')) {
        this.toggleTab(e.target);
      }
    });
  }

  toggleTab(button) {
    if (this.activeButton === button) {
      button.classList.remove('active');
      this.container.innerHTML = '';
      this.activeButton = null;
    } else {
      const buttons = this.titlesContainer.querySelectorAll('button');
      buttons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
      const content = this.accordions[button.dataset.index].dataset.content;
      this.container.innerHTML = content;
      this.activeButton = button;
    }
  }
}



document.addEventListener("DOMContentLoaded", () => {
  new GridViewController();
  initGalleryPDP();

  assignLinkToHeader();
  initProductGalleries();
  initViewMoreButton();

  new AccordionTabs('.product-single' );

});
